/** Cancelled rides keep the ride details readable but visually inactive. */
export const CANCELLED_SECTIONS_OPACITY = 0.6;
